import * as React from 'react';
import { StyledMenuItem, StyledMenuItemIcon } from './styles';

export type MenuItemType = { role?: string } & React.FC<{ className?: string; id?: string; disabled?: boolean, onClick?: React.MouseEventHandler<HTMLLIElement>, icon?: any }>;

export const MenuItem: MenuItemType =
  React.forwardRef((props, ref) => {
    const { children, onClick, icon, disabled } = props;

    if (children) {
      return <StyledMenuItem disabled={disabled} onClick={onClick} ref={ref as any} data-role="menu-item">
        {icon ? <StyledMenuItemIcon component={icon}></StyledMenuItemIcon> : null}{children}
      </StyledMenuItem>;
    }
    return <>{children}</>;
  });
  
MenuItem['role'] = "menu-item";